const GET_DOMAIN = window.location.href;
const DEV_ENV = {
    url: {
        ZIMBRA_MAIL_URL: 'https://vwebmailtest.eircom.net',
        CLASSIC_WEB_MAIL_URL: 'http://webmailclassic.eircom.net/cgi-bin/checkmail.cgi',
        GET_SUBSCRIBER_URL:
            'https://webmail-subscriber-service.dev.webmail.comhar.local/public/webmail/subscriber/',
        WEBMAIL_SUPPORT_URL: 'https://www.eir.ie/support/webmail/',
        FORGOT_PASSWORD_URL: 'https://autoreg.eir.ie/passwordchange/changeunknown_pwd.html',
        OTP_VERIFICATION_URL:
            'https://eir-otp-verification-backend.dev.webmail.comhar.local/public/otp/',
        PROSPECT_URL:
            'https://webmail-prospect-service.dev.webmail.comhar.local/public/webmail/prospect/',
        REALEX_HPP_URL: 'https://pay.sandbox.elavonpaymentgateway.com/pay',
        SUBSCRIBER: 'https://webmail-subscriber-service.dev.webmail.comhar.local',
        PAYER: 'https://eir-payment-center-backend.dev.webmail.comhar.local',
        OTP: 'https://eir-otp-verification-backend.dev.webmail.comhar.local',
        INVOICE: 'https://webmail-billing-service.dev.webmail.comhar.local',
        ADD_CARD: 'https://eir-payment-center-backend.dev.webmail.comhar.local',
        PRIVATE_SUBSCRIBER: 'https://mytt01.eir.ie/wsubsriber',
        PRIVATE_PAYER: 'https://mytt01.eir.ie/wpayer',
        PRIVATE_ADD_CARD: 'https://eir-payment-center-backend.dev.webmail.comhar.local',
        PRIVATE_OTP: 'https://mytt01.eir.ie/wotp',
        PAYMENT_CENTER_STATUS: 'https://my.eir.ie/wpayer/actuator/health',
        PRIVATE_INVOICE: 'https://mytt01.eir.ie/winvoice',
        // eirdigital 990 url updated
        ONE_OFF_PAYMENT: 'https://webmail-prospect-service.dev.webmail.comhar.local',
        PRIVATE_ONE_OFF_PAYMENT: 'https://mytt01.eir.ie/wprospect',
    },
};

const PROD_ENV = {
    url: {
        ZIMBRA_MAIL_URL: 'https://webmail.eir.ie',
        CLASSIC_WEB_MAIL_URL: 'http://webmailclassic.eircom.net/cgi-bin/checkmail.cgi',
        GET_SUBSCRIBER_URL: 'https://wmss.eir.ie/public/webmail/subscriber/',
        WEBMAIL_SUPPORT_URL: 'https://www.eir.ie/support/webmail/',
        FORGOT_PASSWORD_URL: 'https://autoreg.eir.ie/passwordchange/changeunknown_pwd.html',
        OTP_VERIFICATION_URL: 'https://wmss.eir.ie/public/otp/',
        PROSPECT_URL: 'https://wmss.eir.ie/public/webmail/prospect/',
        REALEX_HPP_URL: 'https://pay.elavonpaymentgateway.com/pay',
        SUBSCRIBER: 'https://wmss.eir.ie',
        PAYER: 'https://wmss.eir.ie',
        OTP: 'https://wmss.eir.ie',
        INVOICE: 'https://wmss.eir.ie',
        ADD_CARD: 'https://wmss.eir.ie',
        ONE_OFF_PAYMENT: 'https://wmss.eir.ie',
        PRIVATE_SUBSCRIBER: 'https://my.eir.ie/wsubsriber',
        PRIVATE_PAYER: 'https://my.eir.ie/wpayer',
        PRIVATE_ADD_CARD: 'https://wmss.eir.ie',
        PRIVATE_OTP: 'https://my.eir.ie/wotp',
        PAYMENT_CENTER_STATUS: 'https://my.eir.ie/wpayer/actuator/health',
        PRIVATE_INVOICE: 'https://my.eir.ie/winvoice',
        PRIVATE_ONE_OFF_PAYMENT: 'https://my.eir.ie/wprospect',
    },
};

export const EIR_WEBMAIL_CONST =
    GET_DOMAIN.indexOf('testwww') > 0
        ? DEV_ENV // if test env
        : GET_DOMAIN.indexOf('localhost') > 0
            ? DEV_ENV // change DEV_ENV for development env or PROD_ENV for production
            : PROD_ENV; // if prod env
